import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: rgba(249, 249, 249, 1);
  border-radius: 30px;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const InfoBlock = ({ children, style = {} }: { children: ReactNode; style?: CSSProperties }) => {
  return <Wrapper style={style}>{children}</Wrapper>;
};
